import { EventEmitter } from "events";

export default class PromisifyWorker extends EventEmitter {
  worker: Worker | typeof globalThis;
  constructor(worker: Worker | typeof globalThis) {
    super();
    this.worker = worker;

    worker.onmessage = (message) => {
      this.emit(message.data.type, message.data);
    };
  }

  postMessage(type: string, data: any = {}, transfer: Transferable[] = []) {
    this.worker.postMessage(
      {
        ...data,
        type,
      },
      // @ts-ignore
      transfer
    );
  }

  onMessage(type: string): Promise<any> {
    return new Promise((resolve) => {
      this.once(type, (data) => {
        resolve(data);
      });
    });
  }
}
